export default class laskutusClass {
  constructor() {
    this.isPumppuSuoraLaskutus = true;
    this.isBetoniSuoraLaskutus = false;
  }
  async saveLaskutusToDB(keikkaId, token, socket, varmenne) {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        keikkaId: keikkaId,
        isBetoniSuoraLaskutus: this.isBetoniSuoraLaskutus,
        isPumppuSuoraLaskutus: this.isPumppuSuoraLaskutus,
        varmenne: varmenne,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/keikka/laskutus/ketju/set",
      requestOptions
    );
    return response.ok;
  }
  get laskutusHash() {
    const b = this.isBetoniSuoraLaskutus ? 2 : 3;
    const p = this.isPumppuSuoraLaskutus ? 5 : 7;
    return b * p;
  }

  getLaskuttajaAsiakas(keikkaData, laskuttajaType = "pumppu") {
    if (laskuttajaType === "pumppu") return keikkaData.pumppuToimittaja;
    if (laskuttajaType === "betoni") return keikkaData.betoniToimittaja;
    if (laskuttajaType === "lattia") return keikkaData.lattiaToimittaja;
    return null;
  }

  getMaksajaAsiakas(keikkaData, laskuttajaType = "pumppu") {
    if (laskuttajaType === "pumppu") {
      if (!keikkaData.laskutus.isPumppuSuoraLaskutus) return keikkaData.betoniToimittaja;
      else return keikkaData.asiakas;
    }
    if (laskuttajaType === "betoni") {
      if (!keikkaData.laskutus.isBetoniSuoraLaskutus) return keikkaData.pumppuToimittaja;
      else return keikkaData.asiakas;
    }
    if (laskuttajaType === "lattia") {
      return keikkaData.asiakas;
    }
    return null;
  }
}
